export default "__VITE_ASSET__CLbBCPVM__"